export interface iPageMonitor {
  Pages: {[key: string]: boolean};
  SetPage: (key: string, value: boolean) => void;
}

export const initialPageMonitorValues: iPageMonitor = {
  Pages: {},
    SetPage: (key: string, value: boolean) => {}
}
